import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import TableSkeleton from "../TableSkeleton";

const CommonTable = ({
  tableData,
  tableColumns,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  isFirstColSticky=false,
  isLoading=false,
  rowClassName,
}) => {
  const data = Array.isArray(tableData) ? tableData : [];
  const columns = Array.isArray(tableColumns) ? tableColumns : [{}];

  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      {isLoading ? (
        <TableSkeleton columns={columns.length || 10} rows={pageLimit || 10} />
      ) : (
        <div className="com-table-tb-wrapper">
          <table className="com-table-tb">
            <thead className="com-table-header">
              <tr className="com-table-tr">
                {columns.map((column, index) => (
                  <th
                    key={index}
                    className={`${
                      index === 0 && isFirstColSticky ? "sticky-column" : ""
                    } ${column?.wrapHeader ? "wrap-header" : ""} ${
                      column?.centerAligned ? "center-aligned" : ""
                    }`}
                  >
                    {column?.text}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="com-table-body">
              {data &&
                data.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={rowClassName ? rowClassName(row) : ""}
                  >
                    {columns.map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className={`${
                          colIndex === 0 && isFirstColSticky
                            ? "sticky-column"
                            : ""
                        } ${column?.centerAligned ? "center-aligned" : ""}`}
                      >
                        {column?.formatter
                          ? column?.formatter(row?.[column?.dataField], row)
                          : row?.[column?.dataField]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {tablePagination && (
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </>
  );
};

export default CommonTable;
